import { Award } from "src/domain/award";

const subscriber: Award[] = [
  {
    option: "5% OFF",
    possibility: 5,
    slug: "STORE_PROMOCODE_5",
    image: require("../assets/images/logo-loja.png").default,
    style: {
      backgroundColor: "#22C6FF",
    },
  },
  {
    option: "7% OFF",
    possibility: 5,
    slug: "STORE_PROMOCODE_5",
    image: require("../assets/images/logo-loja.png").default,
    style: {
      backgroundColor: "#fc9900",
    },
  },
  {
    option: "10% OFF",
    possibility: 30,
    slug: "STORE_PROMOCODE_10",
    image: require("../assets/images/logo-loja.png").default,
    style: {
      backgroundColor: "#F36078",
    },
  },
  {
    option: "15% OFF",
    possibility: 25,
    slug: "STORE_PROMOCODE_15",
    image: require("../assets/images/logo-loja.png").default,
    style: {
      backgroundColor: "#8efc00",
    },
  },
  {
    option: "R$ 5,00 OFF",
    possibility: 20,
    slug: "STORE_PROMOCODE_5_REAIS",
    image: require("../assets/images/logo-loja.png").default,
    style: {
      backgroundColor: "#00ABB9",
    },
  },
  {
    option: "R$ 10,00 OFF",
    possibility: 10,
    slug: "STORE_PROMOCODE_10_REAIS",
    image: require("../assets/images/logo-loja.png").default,
    style: {
      backgroundColor: "#FCCC00",
    },
  },
  {
    option: "R$ 20,00 OFF",
    possibility: 10,
    slug: "STORE_PROMOCODE_15_REAIS",
    image: require("../assets/images/logo-loja.png").default,
    style: {
      backgroundColor: "#A537BF",
    },
  },
];

const bestFriday: Award[] = [
  {
    option: "A Janta da Anta 🎵",
    possibility: 1,
    name: "Audiolivro: A Janta da Anta",
    slug: "AUDIO_A_JANTA_DA_ANTA",
    image: "",
    style: {
      backgroundColor: "#22C6FF",
    },
  },
  {
    option: "Joca e Dado 🎵",
    possibility: 1,
    name: "Audiolivro: Joca e Dado",
    slug: "AUDIO_JOCA_E_DADO",
    image: require("../assets/images/logo-loja.png").default,
    style: {
      backgroundColor: "#F36078",
    },
  },
  {
    option: "Altos e Baixos 🎵",
    possibility: 1,
    name: "Audiolivro: Altos e Baixos",
    slug: "AUDIO_ALTOS_E_BAIXOS",
    image: require("../assets/images/logo-loja.png").default,
    style: {
      backgroundColor: "#FCCC00",
    },
  },
  {
    option: "A Janta da Anta 📖",
    possibility: 0,
    name: "Ebook: A Janta da Anta",
    slug: "EBOOK_A_JANTA_DA_ANTA",
    image: require("../assets/images/logo-loja.png").default,
    style: {
      backgroundColor: "#A6CE39",
    },
  },
  {
    option: "Joca e Dado 📖",
    slug: "EBOOK_JOCA_E_DADO",
    name: "Ebook: Joca e Dado",
    image: require("../assets/images/logo-loja.png").default,
    possibility: 0,
    style: {
      backgroundColor: "#A537BF",
    },
  },
  {
    option: "Seu lobo 📖",
    slug: "EBOOK_ENQUANTO_SEU_LOBO_NAO_VEM",
    name: "Ebook: Enquanto seu Lobo não vem",
    image: require("../assets/images/logo-loja.png").default,
    possibility: 0,
    style: {
      backgroundColor: "#00ABB9",
    },
  },
];

const data: { [index: string]: any } = {
  "4": bestFriday,
  "5": subscriber,
};

export default data;
